export class DailyFinanceDTO {}

export default class DailyFinance extends DailyFinanceDTO {
    constructor(DTO: DailyFinanceDTO){
        super();
        Object.assign(this, DTO);
    }
}